import request from '@/utils/request'

let Targeted_trainingApi = {

  /*靶向培训教育列表*/
  list(data) {
    return request._post('/shop/plus.targeted_training.Index/index', data);
},
/*添加靶向培训教育*/
add(data) {
    return request._post('/shop/plus.targeted_training.Index/add', data);
},
/*修改靶向培训教育*/
edit(data) {
    return request._post('/shop/plus.targeted_training.Index/edit', data);
},
/*删除靶向培训教育*/
del(data) {
    return request._post('/shop/plus.targeted_training.Index/del', data);
},
/*靶向培训教育详情*/
detail(data) {
  return request._post('/shop/plus.targeted_training.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.targeted_training.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.targeted_training.Setting/getSetting', data, errorback);
    },
}
export default Targeted_trainingApi;



// WEBPACK FOOTER //
// ./src/api/targeted_training.js